import Layout from '@src/components/layout/layout';
import SubjectSearchPage from '@src/components/subjectSearchPage';
import { graphql } from 'gatsby';
import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';

export const query = graphql`
  query SubjectSearchById($id: String!) {
    contentfulMokomojoDalykoMokytojuPuslapis(id: { eq: $id }) {
      title
      subject {
        image {
          gatsbyImageData(
            quality: 100
            placeholder: BLURRED
            formats: [AUTO, WEBP]
          )
        }
        uniqueId
      }
    }
  }
`;

const subjectSearchTemplate = ({ data, pageContext }) => {
  const locale = pageContext.locale;
  return (
    <Layout
      locale={locale}
      otherSlugs={pageContext.otherSlugs}
      currentSlug={pageContext.slug}
    >
      <SubjectSearchPage data={data} locale={locale} />
    </Layout>
  );
};

export default subjectSearchTemplate;
